import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { BaseComponent } from '@m4u-angular/base/component/BaseComponent';
import { ServiceBagServices, ServiceBagService } from '@m4u-angular/base/component/ServiceBag';
import { BaseState } from '@m4u-angular/base/entities/BaseEntities';
import { SidebarService } from '@m4u-angular/core/framework/sidebar.service';
import { EnumFilterPanelActions } from '@m4u-angular/core/framework/sysenums.enum';
import { BottomSheetContext } from 'swipe-bottom-sheet/angular';

@Component({
    providers: ServiceBagServices,
    selector: 'app-page-filter',
    templateUrl: './page-filter.component.html',
    styleUrls: ['./page-filter.component.scss']
})
export class PageFilterComponent extends BaseComponent<BaseState> {

    @Input() BottomSheetContext: BottomSheetContext<any>;

    constructor(A: ServiceBagService,
        private sidebarService: SidebarService) {
        super(A, 'SideBarComponent', BaseState);
    }

    ApplyFilter() {
        this.A.SysEvents.FilterPanelAction(EnumFilterPanelActions.Apply);
        this.BottomSheetContext && this.BottomSheetContext.dismiss();
        this.sidebarService.Hide("Filters");
    }

    ClearFilter() {
        this.A.SysEvents.FilterPanelAction(EnumFilterPanelActions.Clear);
        this.BottomSheetContext && this.BottomSheetContext.dismiss();
        this.sidebarService.Hide("Filters");
    }

    HasContent(content: any) {
        return content && content.childElementCount > 0;
    }

}
